import React from 'react'
import {makeStyles,Drawer, Divider, CardMedia,
  Box, Typography,Card, IconButton} from '@material-ui/core'
import Listas from './Listas';
import MenuIcon from '@material-ui/icons/Menu'; 
const drawerWidth = 240;

const estilos = makeStyles(theme=>({
    drawer: {
        width: drawerWidth,
        flexShrink: 0,         
      },
      barra:{
        flexGrow:2
    },
    menuButton: {
      marginRight: theme.spacing(2),        
    },
    media: {
      height: 152,
      width: 220, 
      borderRadius: '10px',
    },
    eltoolbar:theme.mixins.toolbar,
    drawerPaper: {
    width: drawerWidth,
    background:theme.palette.primary.main,
    color:'white'
    },
}))

const Cajon = (propiedades) => {
  const misclases =estilos()
  const contacto=(e)=> {
    e.preventDefault()
    window.open("https://daduva.mx");
  }
  return (      
  <Drawer 
    className={misclases.drawer} variant={propiedades.variant??"permanent"}       
    open={propiedades.open} onClose={propiedades.onClose ? propiedades.onClose:null }
    classes={{ paper: misclases.drawerPaper,}}    anchor="left"
  >
    <Box className={misclases.eltoolbar} textAlign="center" pt={2}>
      <Typography variant={propiedades.usuario.Nombre.length>15?"body":"h5"} //color="primary"
        color="inherit"  
      >
        <IconButton color="inherit"   onClick={()=>propiedades.funcionAbrir()} 
          className={misclases.menuButton} aria-label="menu" size='small'
        >
          <MenuIcon/>
        </IconButton>
        {propiedades.usuario.Nombre.toUpperCase()}            
      </Typography>
    </Box>          
    <Divider/>
    <Listas className={misclases.barra}/>
      <Box display="flex" mt={21}  px={1} mb={2} alignItems="flex-end"  alignContent="flex-end">
        <Card  className={misclases.media}>
          <CardMedia                      onClick={contacto}               
            component="img" alt="Logo daduva"
            scaleType="fitCenter" title="Logo daduva"                  
            image="/CIRCULAR_MARGEN_DADUVA20211228.svg"              
          />
        </Card>
      </Box>          
    </Drawer>    
  )
}

export default Cajon
